import { HYDRATE } from 'next-redux-wrapper';

import { ResponseDto } from '@r1-frontend/api-domru/api-content/v1/geography/get-city-info';
import {
    IMenuByTypesItem,
    TMenuKey as TMenuKeyFromResponse,
} from '@r1-frontend/api-domru/api-content/v2/menu/by-types';
import { ICurrentCity } from '@r1-frontend/entities/City/models/ICurrentCity';

import { IAction } from '@r1-frontend/shared/types/Redux';

export const SET_CITIES_LIST = 'SET_CITIES_LIST';
export const SET_CURRENT_CITY = 'SET_CURRENT_CITY';
export const SET_ABN_TESTS = 'SET_ABN_TESTS';
export const SET_PROVIDER = 'SET_PROVIDER';
export const SET_MENU_DATA = 'SET_MENU_DATA';

export const DEFAULT_CURRENT_CITY: ICurrentCity = {
    domain: '',
    hostname: '',
    name: '',
    cityId: 0,
    phone: '',
    callCenter: '',
    callcenterWorkTimeStart: '',
    callcenterWorkTimeEnd: '',
    billingHost: '',
    companyName: '',
    cityIn: '',
    cityTo: '',
    internet: false,
    ctv: false,
    ktv: false,
    telephony: false,
    videocontrol: false,
    phoneCode: 0,
    supportPhone: '',
    legalEntity: '',
    logo: '',
    logoFull: '',
    logo_narrow: '',
    image_map: '',
    image_map_webp: '',
    region: null,
    hasFreeDeliveryAndInstallation: false,
    plAvailable: 0,
    loyaltyProgramCashback: 0,
    timeZone: 0,
    withPromoLines: {
        auth: false,
        unauth: false,
    },
    sso: {
        url: '',
        realm: '',
    },
};

export const initialState: ICityState = {
    currentCity: DEFAULT_CURRENT_CITY,
    citiesList: [],
    provider: {
        providerId: 0,
    },
    abnTests: {
        variants: '',
    },
    newMenuItems: null,
};

export type TAuthorisationDependentMenuKey =  'authMain' | 'unauthMain';

export type TMenuKey = Exclude<TMenuKeyFromResponse, 'main'> | TAuthorisationDependentMenuKey;

export type INewMenuItems = Record<TMenuKey, IMenuByTypesItem[]>

export interface ICityState {
    citiesList: ResponseDto[],
    currentCity: ICurrentCity,
    provider: {
        providerId: number,
    },
    abnTests: {
        variants: string,
        isSended?: boolean,
    },
    newMenuItems: null | INewMenuItems,
}

export type TState = { city: ICityState }

export type THydrateAction = IAction<typeof HYDRATE, TState>

export type TSetCityList = {
    type: typeof SET_CITIES_LIST,
    payload: Partial<Pick<ICityState, 'citiesList'>>,
}

export type TSetCurrentCity = {
    type: typeof SET_CURRENT_CITY,
    payload: Partial<Pick<ICityState, 'currentCity'>>,
}

export type TSetProvider = {
    type: typeof SET_PROVIDER,
    payload: Partial<Pick<ICityState, 'provider'>>,
}

export type TSetAbnTests = {
    type: typeof SET_ABN_TESTS,
    payload: Partial<Pick<ICityState, 'abnTests'>>,
}

export type TSetMenuData = {
    type: typeof SET_MENU_DATA,
    payload: INewMenuItems,
}

type TCityActions = TSetCityList | TSetCurrentCity | TSetProvider | TSetAbnTests | TSetMenuData;

export default (state = initialState, action: TCityActions | THydrateAction): ICityState => {
    switch (action.type) {
        case HYDRATE: {
            return {
                ...state,
                ...action.payload.city,
            };
        }

        case SET_CITIES_LIST:
        case SET_CURRENT_CITY:
        case SET_ABN_TESTS:
        case SET_PROVIDER: {
            return {
                ...state,
                ...action.payload,
            };
        }

        case SET_MENU_DATA:
            return {
                ...state,
                newMenuItems: {
                    ...state.newMenuItems,
                    ...action.payload,
                },
            };

        default: {
            return state;
        }
    }
};
